/* tslint:disable */
/* eslint-disable */
/**
 * Courtiers API
 * API des listes de courtiers (facettes, tri, scope compagnie/admin)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetCourtierListResponse,
  GetFacetsResponse,
  GetGenericListCommandDto,
} from '../models/index';
import {
    GetCourtierListResponseFromJSON,
    GetCourtierListResponseToJSON,
    GetFacetsResponseFromJSON,
    GetFacetsResponseToJSON,
    GetGenericListCommandDtoFromJSON,
    GetGenericListCommandDtoToJSON,
} from '../models/index';

export interface GetAdminCourtierListFacetsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetAdminCourtiersRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetCourtierListFacetsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetCourtiersRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

/**
 * 
 */
export class CourtiersApi extends runtime.BaseAPI {

    /**
     * Facettes (active, categories, plateformes). Permission BackOffice.AdminCourtiers.Read. 
     * Facettes de la liste admin des courtiers (BO admin)
     */
    async getAdminCourtierListFacetsRaw(requestParameters: GetAdminCourtierListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacetsResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getAdminCourtierListFacets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/courtiers/admin/liste/filtres`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacetsResponseFromJSON(jsonValue));
    }

    /**
     * Facettes (active, categories, plateformes). Permission BackOffice.AdminCourtiers.Read. 
     * Facettes de la liste admin des courtiers (BO admin)
     */
    async getAdminCourtierListFacets(requestParameters: GetAdminCourtierListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacetsResponse> {
        const response = await this.getAdminCourtierListFacetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liste admin paginée de tous les courtiers (même format que la route compagnie). Permission BackOffice.AdminCourtiers.Read (403 sinon). 
     * Lister tous les courtiers (BO admin)
     */
    async getAdminCourtiersRaw(requestParameters: GetAdminCourtiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCourtierListResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getAdminCourtiers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/courtiers/admin/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCourtierListResponseFromJSON(jsonValue));
    }

    /**
     * Liste admin paginée de tous les courtiers (même format que la route compagnie). Permission BackOffice.AdminCourtiers.Read (403 sinon). 
     * Lister tous les courtiers (BO admin)
     */
    async getAdminCourtiers(requestParameters: GetAdminCourtiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCourtierListResponse> {
        const response = await this.getAdminCourtiersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Facettes du panneau de filtres (active, categories, plateformes). Envoyer les filtres courants dans le body. Permission BackOffice.Courtiers.Read. 
     * Facettes de la liste des courtiers (rôle compagnie)
     */
    async getCourtierListFacetsRaw(requestParameters: GetCourtierListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacetsResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getCourtierListFacets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/courtiers/liste/filtres`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacetsResponseFromJSON(jsonValue));
    }

    /**
     * Facettes du panneau de filtres (active, categories, plateformes). Envoyer les filtres courants dans le body. Permission BackOffice.Courtiers.Read. 
     * Facettes de la liste des courtiers (rôle compagnie)
     */
    async getCourtierListFacets(requestParameters: GetCourtierListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacetsResponse> {
        const response = await this.getCourtierListFacetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liste paginée des courtiers. La compagnie cible ses courtiers via le filtre/facette plateformes. Permission BackOffice.Courtiers.Read (403 sinon). searchString cherche sur raison sociale, email, téléphone, SIRET, ORIAS, nom/prénom du contact. 
     * Lister les courtiers (rôle compagnie)
     */
    async getCourtiersRaw(requestParameters: GetCourtiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCourtierListResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getCourtiers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/courtiers/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCourtierListResponseFromJSON(jsonValue));
    }

    /**
     * Liste paginée des courtiers. La compagnie cible ses courtiers via le filtre/facette plateformes. Permission BackOffice.Courtiers.Read (403 sinon). searchString cherche sur raison sociale, email, téléphone, SIRET, ORIAS, nom/prénom du contact. 
     * Lister les courtiers (rôle compagnie)
     */
    async getCourtiers(requestParameters: GetCourtiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCourtierListResponse> {
        const response = await this.getCourtiersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
